export default "__VITE_ASSET__CPe17Hkg__"